ko.components.register('domains-grid-presets', {
	viewModel: function(params) {
		var self = this;

		self.ajaxUrl = params && params.ajaxUrl || App.urls.ajax || '';

		self.grid = ko.observable(params && params.grid || null);
		self.label = ko.observable(params && params.label || 'Columns');
		self.placeholder = ko.observable(params && params.placeholder || 'Preset name');
		self.addLabel = ko.observable(params && params.addLabel || 'Add');
		self.deleteLabel = ko.observable(params && params.deleteLabel || '&times;');
		self.deleteConfirm = ko.observable(params && params.deleteConfirm || 'Are you sure?');
		self.applyLabel = ko.observable(params && params.applyLabel || 'Apply');
		self.presetNameHelp = ko.observable(params && params.presetNameHelp || 'Must be unique');

		self.columns = ko.observableArray();
		self.presets = ko.observableArray();
		self.custom = ko.observableArray();
		self.selectedPreset = ko.observable();
		self.selectedColumns = ko.observableArray();

		self.customPresetName = ko.observable('');

		self.help = ko.observable('');

		self.isOpen = ko.observable(params && params.isOpen || false);
		self.loading = ko.observable(false);

		self.toggle = function() {
        	self.isOpen(!self.isOpen());
        	if(!self.isOpen() && self.grid) {
        		self.saveData().done(function(){
                    $.fn.yiiGridView.update(self.grid());
				});
			}
		};

		self.setData = function(data) {
			self.columns($.map(data && data.columns || [], function(item){
				return new GridColumn(item);
			}));
			self.presets($.map(data && data.presets || [], function(item){
				return new GridPreset(item);
			}));
			self.custom($.map(data && data.custom || [], function(item){
				return new GridPreset(item);
			}));
			self.selectedPreset(data && data.selectedPreset || '');
			self.selectedColumns(data && data.selectedColumns || []);
		};

		self.getCustomPresetsData = function() {
			var data = [];
			for(var k in self.custom())
				data.push(self.custom()[k].getData());
			return data;
		};

		self.getData = function() {
			return {
				custom: self.getCustomPresetsData(),
				selectedPreset: self.selectedPreset(),
				selectedColumns: self.selectedColumns()
			};
		};

		self.getPresets = function() {
			return $.map(self.presets(), function(item){
				item.selected(item.name() == self.selectedPreset());
				return item;
			});
		};

		self.getCustomPresets = function() {
			return $.map(self.custom(), function(item){
				item.selected(item.name() == self.selectedPreset());
				return item;
			});
		};

		self.getPresetColumns = function(name) {
			var presets = [].concat(self.getPresets(), self.getCustomPresets()).filter(function(i){ return i.name() == name});
			if(presets.length)
				return presets.pop().columns();
			return [];
		};

		self.getSelectedColumns = function() {
			return $.map(self.columns(), function(item){
				item.selected(self.selectedColumns().indexOf(item.name()) != -1);
				return item;
			});
		};

		self.toggleColumn = function(item) {
			self.selectedPreset('');
			if(item.selected())
				self.selectedColumns.remove(item.name());
			else
				self.selectedColumns.push(item.name());
		};

        self.isColumnChecked = function(column) {
            return self.selectedColumns.filter(function(i){ return i == column.name()}).length > 0;
        };

		self.selectPreset = function(preset) {
			self.customPresetName('');
			self.selectedPreset(preset.name());
			self.selectedColumns(self.getPresetColumns(preset.name()));
		};

		self.hasCustomPresetName = function() {
			var name = self.customPresetName();
			return name && name.length > 2;
		};

		self.addCustomPreset = function() {
			if(self.hasCustomPresetName()) {
				self.custom.push(new GridPreset({
					name: self.customPresetName(),
					label: self.customPresetName(),
					columns: self.selectedColumns()
				}));
			}
		};

		self.deleteCustomPreset = function(preset) {
			if(confirm(self.deleteConfirm()))
				self.custom.remove(preset);
		};

		self.ajaxRequest = function(action, data) {
            if(self.loading())
                return;
            self.loading(true);
            return $.ajax({
                url: self.ajaxUrl,
                type: 'post',
                dataType: 'json',
                data: $.extend(data ? { 'action': action, 'data': data } : { 'action': action }, App.csrf||{})
            }).always(function(){
                self.loading(false);
            });
		};

		self.loadData = function() {
			return self.ajaxRequest('load').done(function(r){
                if(r && r.ok)
                {
                	if(r.data)
                    	self.setData(r.data);
                    if(r.help)
						self.help(r.help);
                }
                if(r && r.error)
                    alert(r.error);
			});
        };

        self.saveData = function() {
            return self.ajaxRequest('save', self.getData());
        };

        self.loadData();
    },
    template: "<button class=\"btn btn-light\" data-bind=\"click: toggle, css: { 'active': isOpen()}\">\n\t<span class=\"ic ic-columns\"></span>\n\t<span data-bind=\"text: label()\"></span>\n</button>\n<div class=\"row mb-4 border border-gray py-2 shadow\" style=\"margin-top:-1px\" data-bind=\"visible: isOpen\">\n\t<div class=\"col-md-4 col-lg-3\">\n\t\t<ul class=\"list-group list-group-flush\" data-bind=\"foreach: getPresets()\">\n\t\t\t<li class=\"list-group-item list-group-item-action py-1 cursor-pointer\" data-bind=\"click: $parent.selectPreset, css: {'active': selected()}\">\n\t\t\t\t<span data-bind=\"text: label()\"></span>\n\t\t\t\t<small class=\"badge badge-pill badge-light text-muted\" data-bind=\"text: columns().length\"></small>\n\t\t\t</li>\n\t\t</ul>\n\n\t\t<div class=\"input-group my-2\">\n\t\t\t<input class=\"form-control\" type=\"text\" data-bind=\"textInput: customPresetName, attr: {placeholder: placeholder()}\" />\n\t\t\t<div class=\"input-group-append\">\n\t\t\t\t<button class=\"btn btn-primary btn-sm\" data-bind=\"click: addCustomPreset, text: addLabel, enable: hasCustomPresetName()\"></button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<ul class=\"list-group list-group-flush\" data-bind=\"foreach: getCustomPresets()\">\n\t\t\t<li class=\"list-group-item list-group-item-action py-1 cursor-pointer\" data-bind=\"click: $parent.selectPreset, css: {'active': selected()}\">\n\t\t\t\t<span data-bind=\"text: label()\"></span>\n\t\t\t\t<small class=\"badge badge-pill badge-light text-muted\" data-bind=\"text: columns().length\"></small>\n\t\t\t\t<button class=\"close\" data-bind=\"click: $parent.deleteCustomPreset, html: $parent.deleteLabel()\"></button>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<div class=\"col-md-8 col-lg-9\">\n\t\t<div data-bind=\"foreach: getSelectedColumns()\">\n\t\t\t<button class=\"m-1 btn btn-sm\" data-bind=\"click: $parent.toggleColumn, css: {'btn-primary': selected(), 'btn-light': !selected()}\">\n\t\t\t\t<span data-bind=\"text: label()\"></span>\n\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<div class=\"col-md-4 col-lg-3\">\n\t\t<div data-bind=\"visible: help().length\">\n\t\t\t<hr />\n\t\t\t<div class=\"text-muted border-left border-warning pl-2\">\n\t\t\t\t<small class=\"ic ic-help\"></small>\n\t\t\t\t<small data-bind=\"html: help()\"></small>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"col-md-8 col-lg-9 align-bottom\">\n\t\t<button class=\"btn btn-light btn-outline-success btn-block mt-5\" data-bind=\"click: toggle, text: applyLabel()\"></button>\n\t</div>\n</div>"
});